import { Button, Card, Modal, Skeleton } from 'antd';
import { memo, useMemo } from 'react';

import { CloseIconsForModalWithDataTestId } from '@app/components';
import { PREFIX } from '@app/constants/appPrefix';
import { generateSpanWithDataTestId } from '@app/shared/utils';

import { useUserPreview } from '@pages/Users/UserPreview/hooks/useUserPreview';

import {
  ActivityInfo,
  AdditionalInfo,
  BranchesInfo,
  PersonalInfo,
} from '@pages/Users/UserPreview/components';

import '@pages/Users/UserPreview/styles/UserPreview.desktop.scss';
import '@pages/Users/UserPreview/styles/UserPreview.tablet.scss';
import '@pages/Users/UserPreview/styles/UserPreview.mobile.scss';

export const UserPreview = memo(() => {
  const {
    user,
    isLoading,
    contextHolder,
    chains,
    isModalOpen,
    setIsModalOpen,
    isLetterSending,
    sendLetter,
    hasUserRightToEdit,
    restoreUser,
    isUnarchiveUserLoading,
  } = useUserPreview();

  const isNeedToShowAdditionalInfoCard = useMemo(
    () =>
      (!!user && user?.DateBirth) ||
      user?.Gender ||
      user?.DateWorkStart ||
      user?.DatePatentEnd ||
      user?.Citizenship ||
      user?.PassportInfo ||
      (user?.TaxPayerId && user?.TaxPayerId !== 0) ||
      user?.InsuranceCertificateN,
    [user]
  );

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <>
      <div className={`${PREFIX}user-preview`}>
        {contextHolder}
        <Card
          title={generateSpanWithDataTestId(
            'Основная информация',
            'main-info-block'
          )}
          className="personal-info"
        >
          <PersonalInfo
            user={user}
            restoreUser={restoreUser}
            isUnarchiveUserLoading={isUnarchiveUserLoading}
          />
        </Card>

        <Card
          title={generateSpanWithDataTestId('Активность', 'activity-block')}
          className="activity-info"
        >
          <ActivityInfo user={user} />
        </Card>

        <Card
          title={generateSpanWithDataTestId('Филиалы', 'branches-block')}
          className="branches-info"
        >
          <BranchesInfo user={user} chains={chains} />
        </Card>

        {isNeedToShowAdditionalInfoCard && (
          <Card
            title={generateSpanWithDataTestId(
              'Дополнительная информация',
              'additional-info-block'
            )}
            className="additional-info"
          >
            <AdditionalInfo user={user} />
          </Card>
        )}
      </div>
      {hasUserRightToEdit && user?.IsDeleted === false && (
        <Button
          type="primary"
          className="send-letter"
          size="large"
          onClick={() => setIsModalOpen(true)}
          data-testid="send-invite"
        >
          Отправить приглашение
        </Button>
      )}
      <Modal
        open={isModalOpen}
        title={generateSpanWithDataTestId(
          'Подтверждение действия',
          'confirm-invite-title'
        )}
        onCancel={() => setIsModalOpen(false)}
        okText="Подтвердить"
        cancelText="Отменить"
        okButtonProps={{
          loading: isLetterSending,
          'data-testid': 'submit-invite',
        }}
        cancelButtonProps={{
          disabled: isLetterSending,
          'data-testid': 'cancel-invite',
        }}
        onOk={sendLetter}
        data-testid="send-invite-popup"
        closeIcon={<CloseIconsForModalWithDataTestId />}
      >
        <span data-testid="confirm-invite-description">
          Отправить приглашение в ByHelp на {user?.Email}?
        </span>
      </Modal>
    </>
  );
});
